import HeaderFooterBaseConnected from './HeaderFooterBase'

export default HeaderFooterBaseConnected
